import { render, staticRenderFns } from "./KolonneSettingsCrudVehiclesRankingLegend.vue?vue&type=template&id=da394e9c"
import script from "./KolonneSettingsCrudVehiclesRankingLegend.vue?vue&type=script&lang=js"
export * from "./KolonneSettingsCrudVehiclesRankingLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports